module.exports = __webpack_public_path__ + "static/HF_JSMS-d1105d16f35a1a895ff2c869755e583f.png";